module.exports = __webpack_public_path__ + "5bd3e42e2d2523cb42614099219289.png";